/** Comma-separated extension allowlist (e.g. `pdf,docx`). Aligned with backend DocumentUpload. */
export const OWN_UPLOAD_DEFAULT_ALLOWED_EXTENSIONS = 'pdf,docx';

/** 49 MiB — client-side guard; backend enforces a lower limit via DocumentUpload:MaxFileSizeBytes. */
export const OWN_UPLOAD_DEFAULT_MAX_FILE_SIZE_BYTES = 51_380_224;

/** Backend `DocumentUploadOptions.MaxFilesPerRequest`. */
export const OWN_UPLOAD_MAX_FILES_PER_REQUEST = 10;

/** Interval between indexing-status polls while the upload dialog waits for documents to become terminal. */
export const OWN_UPLOAD_POLL_INTERVAL_MS = 2000;

/** Safety valve: stop polling after this long so a never-terminal document cannot trap the dialog forever. */
export const OWN_UPLOAD_POLL_TIMEOUT_MS = 300_000;
